import React, { useEffect, useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { html_render } from "pages/Review/Functions";

const Editor = (props, _ref) => {
    const { reviewData , webContent } = props;
    const [Hide, SetHide] = useState(false);
    const reviewRef = useRef(null);
    const [WEB_CONTENT, SET_WEB_CONTENT] = useState(null);

    const HandleHide = () => {
        SetHide(!Hide);
    }

    useEffect(() => {
        const review = reviewData?.filter((f) => f.celNm === "Description Review Data");
        if( !webContent) return;
        let content = [];
        if( review ){
            content = html_render(webContent, review);
        }else{
            content = webContent;
        }
        SET_WEB_CONTENT(content);
    },)

    const HandleReviewEvent = ({ target }) => {
        const isUniqueCode = target?.closest("[data-uniquecode]");
        if (!isUniqueCode) return;

        const uniqueCode = isUniqueCode.dataset.uniquecode;
        if (!uniqueCode) return;

        reviewRef.current.querySelectorAll(".selected").forEach((e) => {
            e.classList.remove("selected");
        });
        target.classList.add("selected");
        props?.onOpen && props.onOpen({ name: "Description Review Data", revType:"D" }, uniqueCode);

    };

    useEffect(() => {
        reviewRef.current?.addEventListener("click", HandleReviewEvent);
        return () => {
            reviewRef.current?.removeEventListener("click", HandleReviewEvent);
        };
    }, [WEB_CONTENT]);

    return (
        <section className="detail">
            <div className={"tbl_box2 " + (Hide ? "hide" : "")}>
                <h1 className={"title "} onClick={HandleHide}>
                    {"Sheet Description"} <FontAwesomeIcon icon={faAngleUp} />
                </h1>
                <div className="data_table editor-div"> 
                    <div className={"view-area"}>
                        <div className={"inner"}>
                                <div ref={reviewRef} className={"ck-content ck-readnonly"} dangerouslySetInnerHTML={{ __html: WEB_CONTENT || "" }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default React.forwardRef(Editor);
